<template>
<div id="pickSchool">
    <!-- <v-layout> -->
    <v-card style="background-color:white;min-height:100vh" @scroll.passive="bottomVisible">
        <v-layout>
            <v-flex xs12 class="searchWrap">
                <v-text-field placeholder="Cari Nama Sekolah..." clearable @click:append="submitSearchSchool" append-icon="search" @keyup.enter="submitSearchSchool" dark class="searchsearch" id="searchSchool" @click:clear="clearSearch" v-model="searchSchool"></v-text-field>
            </v-flex>
        </v-layout>
        <v-container>
            <v-list>
                <v-list-tile style="height:60px;" v-for="(item,index) in schoolList" :key="index" @click="schoolClicked(item)">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <p>{{item.school_t}}</p>
                        </v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.city_name_s + ' - ' +item.province_name_s"></v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-layout>
                <v-flex xs12>
                    <div class="loading" style="display:flex; justify-content:center;align-items:center; padding:10px;" v-if="loading">
                        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container v-if="schoolList.length < 1 && loading === false">
            <v-layout row wrap>
                <!-- <v-flex xs12 style="display:flex;justify-content:center;"> -->
                <!-- <img src="@/assets/icon/img_seriduel.png" alt="upssss"> -->
                <!-- </v-flex> -->
                <v-flex xs12 style="text-align:center;">
                    <!-- <h2 style="color:#EA0101; font-weight:400;">Waah, tidak ketemu ya?</h2> -->
                    <span v-if="searchSchool">Data tidak ditemukan. <br />Periksa koneksi internet atau ejaan pencarian</span>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
    <!-- </v-layout> -->
</div>
</template>

<style scoped>
.searchWrap {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    background-color: #0097D3;
    margin: 12px;
}

.v-list__tile__content {
    border-bottom: solid 1px lightgray !important;
}

.v-input.searchsearch .v-input__control .v-input__slot {
    /* border-radius:1px !important; */
    border: none !important;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'pickSchool-component',
  mounted () {},
  data () {
    return {
      valid: true,
      notifInfo: false,
      notifError: false,
      jenjang: '',
      selectedSchool: null,
      pickSchool: false,
      searchSchool: '',
      addSchool: false,
      confirmAddSchool: false,
      schoolList: [],
      provinceList: [],
      verified: null,
      citiesList: [],
      bottom: false,
      params: {
        grade: '',
        search: '',
        page: 1
      },
      reachedBottom: false,
      lastScrollUpdate: 0,
      loading: false,
      addSchoolForm: {
        jenjang: null,
        province_code: null,
        province: null,
        city_code: null,
        city: null,
        school: null
      },
      schoolNameRules: [
        v => !!v || 'Nama sekolah harus diisi',
        v => !/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi.test(v) || 'Nama sekolah tidak valid'
      ]
    }
  },
  watch: {
    addSchool (to, from) {
      if (to) {
        this.$store.dispatch('funcProvince').then(response => {
          this.provinceList = response.data
        })
        this.$refs.form.reset()
        this.addSchoolForm = {
          jenjang: null,
          province_code: null,
          province: null,
          city_code: null,
          city: null,
          school: null
        }
      }
    },
    bottom (bottom) {
      if (bottom) {
        this.getSchool()
      }
    }
  },
  methods: {
    bottomVisible () {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      if (bottomOfPage || pageHeight < visible) {
        var t = new Date().getTime()
        if ((t - this.lastScrollUpdate) > 1500) {
          this.lastScrollUpdate = t
          return true
        }
      }
    },
    addSchoolDialog () {
      this.pickSchool = false
      this.addSchool = true
    },
    getSchool: function () {
      this.pickSchool = true
      this.loading = true
      var context = this
      this.params.search = this.searchSchool ? this.searchSchool : ''
      // this.$store.dispatch('funcSchoolsSNMPTN', this.params).then(response => {
      //   if (response.data.length) {
      //     this.params.page += 1
      //     this.schoolList.push(...response.data)
      //   }
      //   setTimeout(function () { context.loading = false }, 2000)
      // }).catch(function (error) {
      //   // this.schoolList = []
      //   setTimeout(function () { context.loading = false }, 2000)
      // })

      var queryStr = 'q=*:*&'
      if (this.params.search !== '') queryStr = 'q=' + this.params.search + '&'
      // if(this.params.search == '') this.params.page = 0
      axios(process.env.VUE_APP_API_ENDPOINT + '/search/nfj_schools/select?' + queryStr +
                'defType=edismax&fq=jenjang_s%3ASMA&qf=school_s&wt=json&rows=10&start=' + this.params.page, {
        auth: {
          username: process.env.VUE_APP_SOLR_USERNAME,
          password: process.env.VUE_APP_SOLR_PASSWORD
        }
      }).then((response) => {
        // var ctx = this
        var hits = response.data.response.docs
        if (hits.length > 0) {
          this.params.page += 1 * 10
          this.schoolList.push(...hits)
        }
        setTimeout(function () {
          context.loading = false
        }, 2000)
      }).catch(function (error) {
        this.schoolList = []
        setTimeout(function () {
          context.loading = false
        }, 2000)
        console.log(error)
      })
    },
    getCities (item) {
      this.$store.dispatch('funcCities', item).then(response => {
        this.citiesList = response.data
      })
    },
    clearSearch: function () {
      this.searchSchool = ''
      this.schoolList = []
      this.getSchool()
    },
    submitSearchSchool: function () {
      this.params.page = 0
      this.schoolList = []
      this.getSchool()
    },
    schoolClicked: function (item) {
      item.school_name = item.school_t
      this.$store.commit('selectedSchool', item)
      this.$router.push('/rasionalisasi')
    },

    sheetClose () {
      this.sheet = true
    }
  },
  created () {
    if (!this.$store.state.profile.pickedSchool.from) {
      this.$store.commit('schoolForm', {
        from: this.$route.query.f,
        value: ''
      })
    }
    window.addEventListener('scroll', () => {
      this.bottom = this.bottomVisible()
    })
    this.getSchool()
  }
}
</script>
